export const Appconfig = {
    APIENDPOINT: {
        IT_STRATEGIES: {
            ROOT: '1/itstrategies'
        },
        ME: {
            ACTIVITY_LOGS: '1/me/activity/report',
            CLEAR_ACTIVITY_LOGS: '1/me/activity/log/cleared'
        },
        GET_MODULES_FEATURES: "1/me/getmodulesandfeatures",
        AUTH_MODULE: {
            LOGIN: '1/users/login',
            RESET: '1/users/resetpassword',
            LOGOUT: '1/users/logout',
            FORGOT_PASSWORD: '1/users/forgotpassword',
            TWO_FA: '1/me/2fa/verify',
            RESET_2FA: '1/me/reset/qr',
            SESSION: '1/users/check/session',
            RESET_DETAILS: '1/users/userforresetid/',
            GET_TWO_FACTOR_SECRET: '1/me/2fa/secret',
            SIGNED_COOKIES: '1/users/get-cookies',
            VERIFY_TOKEN:'1/users/verifytoken'
        },
        HOME_MODULES: {
            ACCOUNT: '1/me/account',
            ACCOUNT_UPDATE: '1/me/update',
            RESET_PASSWORD: '1/me/account/users',
            COMPANIES: '1/me/companies',
            USERS: '1/me/account/users',
            ME_USERS: '1/me/users',
            ACC_LEVEL_CONFIG: '1/me/get-account-level-data',
            SET_ACC_LEVEL_CONFIG: '1/me/set-account-level-data',
            IMG_ACCOOUNT: '1/me/v3/account/',
            IMAGE_GALLERY: '/image-gallery',
            LINE_ICONS: '1/me/v3/line-icons',
            LINE_ICON_CATEGORIES: '1/me/v3/get-line-icons-cat',
            INDUSTRIES: '1/me/industries'
        },
        SETTINGS: {
            MAKE_ADMIN: '1/users/additional-admin/add',
            REMOVE_ADMIN: '1/users/additional-admin/remove',
            PACKAGE_DETAILS: '1/me/package/eligibility/bu/'
        },
        XADMINS: {
            ACCOUNT: '1/me/account',
            ACCOUNTS: '1/xadmins/accounts',
            COUNTRIES: '1/geo/countries',
            MODULES: '1/me/modules',
            INDUSTRIES: '1/me/industries',
            PREFERENCES: '1/xadmins/preferences',
            ACC_LEVEL_CONFIG: '1/me/get-account-level-data'
        },
        INPUT_MODULES: {
            ITDIAGNOSTICS: '1/itstrategies',
            BUSINESSSTRATEGY: '1/itstrategies',
            TECHSTRATEGY: '1/itstrategies',
            ITOPERATING: '1/itstrategies',
        },
        DATA: {
            COUNTRIES: '1/geo/countries',
            INDUSTRIES: '1/me/industries',
            FEATURES_AND_MODULES: '1/me/getmodulesandfeatures'
        },
        INPUT_MANAGE_PROJECT: {
            COMPANIES: '1/me/companies/',
            CORE: '1/itstrategies/',
            PROJECT_DATA: '/masterdata/projectdata',
            SUPPLIER_DATA: '/masterdata/supplierdata',
            HR_DATA: '/masterdata/hrdata',
            OT_DATA: '/masterdata/otdata',
            OT_ADD_NEW_DATA: '/masterdata/add/otdata',
            CATEGORIES_UNIQUE_OT_DATA: '/categories-unique-values/otdata',
            UPLOAD_OT_DATA: '/foundations/files/otdata',
            APP_DATA: '/masterdata/applicationdata',
            APP_ADD_NEW_DATA: '/masterdata/add/applicationdata',
            PROJECT_ADD_NEW_DATA: '/masterdata/add/projectdata',
            SUPPLIER_ADD_NEW_DATA: '/masterdata/add/supplierdata',
            HR_ADD_NEW_DATA: '/masterdata/add/hrdata',
            CRITICAL_APP_DATA: '/applications/critical',
            CATEGORIES_UNIQUE_PROJECT_DATA: '/categories-unique-values/projectdata',
            CATEGORIES_UNIQUE_APP_DATA: '/categories-unique-values/applicationdata',
            CATEGORIES_UNIQUE_SUPPLIER_DATA: '/categories-unique-values/supplierdata',
            APPLICATION_DATA: '/masterdata/applicationdata',
            UPLOAD_DATA: '/modules/fnd',
            UPLOAD_APP_DATA: '/foundations/files/applicationdata',
            UPLOAD_PROJ_DATA: '/foundations/files/programmedata',
            UPLOAD_SUPPLIER_DATA: '/foundations/files/supplierdata',
            UPLOAD_HR_DATA: '/foundations/files/hrdata',
            ACC_LEVEL_CONFIG: '1/me/get-account-level-data/',
            UPLOAD_IMAGE: '1/me/v3/upload/image'
        },
        BUSINESS_STRATEGY_INPUT: {
            OBJECTIVES: '/modules/objectives',
            CRITICAL_PROJECTS: '/masterdata/programmedata/projects/critical'
        },
        CANVAS: {
            CORE: '1/itstrategies/v3/',
            CREATE: '/canvas/create',
            GET: '/canvas/get/',
            LIST: '/canvas/list/',
            REMOVE: '/canvas/remove/',
            REORDER: '/canvas/reorder/tabs/',
        }
    },
    BUSINESS_MODULES: [{
        name: "UPLOAD & MANAGE DATA",
        details: "Collate and prepare data for strategy formulation.",
        icon: "../../../../../../assets/images/uploads/manage_data_2.svg",
        route: 'managedata',
        screenName: 'manage_data'
    }, {
        name: "IT DIAGNOSTIC",
        details: "Assess maturity, risk, what’s broken and where the gaps are.",
        icon: "../../../../../../assets/images/uploads/current_state.svg",
        route: 'itdiagnostic',
        screenName: 'it_diagnostic'
    }, {
        name: "BUSINESS STRATEGY",
        details: "Capture business vision, goals, objectives and success measures. Identify and assess market conditions and sector trends.",
        icon: "../../../../../../assets/images/uploads/business_strategy.svg",
        route: 'businessstrategy',
        screenName: 'business_strategy'
    }, {
        name: "TECHNOLOGY STRATEGY",
        details: "Establish how technology will enable business. Outline big technology bets that will future-proof the business.",
        icon: "../../../../../../assets/images/uploads/tech_strategy.svg",
        route: 'techstrategy',
        screenName: 'technology_strat'
    }, {
        name: "IT OPERATING MODEL",
        details: "Define how IT will operate. Design IT organisation and services to support technology bets.",
        icon: "../../../../../../assets/images/uploads/it_operating_model.svg",
        route: 'itoperatingmodel',
        screenName: 'it_operating_model'
    }, {
        name: "GOVERN & DELIVER",
        details: "Make investment decisions and assign priority. Optimise portfolio to best deliver IT Strategy. Monitor and oversee benefits delivery.",
        icon: "../../../../../../assets/images/uploads/govern.png",
        route: 'governdeliver',
        screenName: 'govern_and_deliver'
    }],
    EXCEL_DOWNLOAD_TEMPLATES: {
        APP_DATA: 'https://xiroccowebassets.s3.eu-west-1.amazonaws.com/sample-master-data/rel3-application-data-v1.xlsx',
        PROJECT_DATA: 'https://xiroccowebassets.s3.eu-west-1.amazonaws.com/sample-master-data/rel3-project-data-v1.xlsx',
        HR_DATA: 'https://xiroccowebassets.s3.eu-west-1.amazonaws.com/sample-master-data/rel3-hr-data-v1.xlsx',
        SUPPLIER_DATA: 'https://xiroccowebassets.s3.eu-west-1.amazonaws.com/sample-master-data/rel3-supplier-data-v1.xlsx',
        OT_DATA: 'https://xiroccowebassets.s3.eu-west-1.amazonaws.com/sample-master-data/rel3-ot-data-v1.xlsx'
    },
    CriticalColorIndicators: {
        'red': '#FF0000',
        'amber': '#FF8C00',
        'green': '#228B22',
        'grey': '#cbcbcb',
        'deep-red': '#8b0000'
    },
    colorPalette: ['#0A8E92', '#abf1af', '#AFEEEE', '#D2B48C', '#DAA520', '#4682B4', '#FF1493', '#800000', '#FFE4C4', '#FF4500', '#00FFFF', '#A0522D', '#2E8B57', '#8B0000', '#A0522D', '#FA8072', '#008B8B', '#20B2AA', '#FFFFE0', '#F0FFFF', '#FF7F50', '#00FFFF', '#A0522D', '#2E8B57', '#8B0000', '#A0522D', '#FA8072', '#008B8B', '#20B2AA', '#FFFFE0', '#F0FFFF', '#FF7F50'],

    defaultCanvas: 'data:image/svg+xml;base64,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'
}



